import React from 'react';
import ReactDOM from 'react-dom';
import { ClientProvider } from '@micro-stacks/react';

import { App } from './App';
import reportWebVitals from './reportWebVitals';

import './index.scss';
import 'react-loading-skeleton/dist/skeleton.css';
import './scss/globals.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const baseAuthOptions = {
  redirectTo: '/',
  manifestPath: '/manifest.json',
  appDetails: {
    name: 'Asigna',
    icon: `${window.origin}/favicon.ico`,
  },
};

ReactDOM.render(
  <ClientProvider
    appName={baseAuthOptions.appDetails.name}
    enableNetworkSwitching
    appIconUrl={baseAuthOptions.appDetails.icon}
    onNoWalletFound={() => {
      // showModal({
      //   body: <></>
      // }) // TODO: make a stub modal when there's no STX wallet installed
    }}
  >
    <App />
  </ClientProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or bridge to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

/**
 * All supported classes - to override library classes:
 *
 * text-primary text-primary-3 text-primary-5 text-primary-10 text-primary-20 text-primary-30
 * text-white text-white-3 text-white-5 text-white-10 text-white-20 text-white-30
 * text-regular
 * text-success text-success-3 text-success-5 text-success-10 text-success-20 text-success-30
 * text-error text-error-3 text-error-5 text-error-10 text-error-20 text-error-30
 * text-black-0 text-black-1 text-black-2 text-black-3 text-black-4 text-orange text-inherit
 *
 * bg-primary bg-primary-3 bg-primary-5 bg-primary-10 bg-primary-20 bg-primary-30
 * bg-white bg-white-3 bg-white-5 bg-white-10 bg-white-20 bg-white-30
 * bg-regular
 * bg-success bg-success-3 bg-success-5 bg-success-10 bg-success-20 bg-success-30
 * bg-error bg-error-3 bg-error-5 bg-error-10 bg-error-20 bg-error-30 bg-orange
 * bg-black-0 bg-black-1 bg-black-2 bg-black-3 bg-black-4
 *
 * text-m16 text-m15 text-m14 text-m13 text-m12 text-r24 text-r20 text-r16 text-r14 text-r13 text-r12
 */
